<template>
  <div class="control">
    <input
      type="checkbox"
      :value="value"
      @change="updateInput"
      :id="id"
      :checked="shouldBeChecked"
      :class="{'is-checked': shouldBeChecked}"
    />
    <span></span>
    <label :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
import "@/assets/style/fonts.sass";
export default {
  model: {
    prop: "modelValue",
    event: "change"
  },
  props: {
    value: {
      type: String
    },
    modelValue: {
      default: false
    },
    trueValue: {
      default: true
    },
    falseValue: {
      default: false
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    shouldBeChecked() {
      if (this.modelValue instanceof Array) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue === this.trueValue;
    }
  },
  methods: {
    updateInput(event) {
      let isChecked = event.target.checked;

      if (this.modelValue instanceof Array) {
        let newValue = [...this.modelValue];

        if (isChecked) {
          newValue.push(this.value);
        } else {
          newValue.splice(newValue.indexOf(this.value), 1);
        }

        this.$emit("change", newValue);
      } else {
        this.$emit("change", isChecked ? this.trueValue : this.falseValue);
      }
    }
  }
};
</script>